import React from "react";
import SlotTimeList from "./SlotTimeList";

const VacationList = ({
  showLoader,
  vacations,
  editVacation,
  handleDeleteVacation,
}) => {
  return (
    <>
      {vacations && vacations.length > 0 ? (
        <div
          style={{
            paddingLeft: window.innerWidth > 768 ? "18px" : "4px",
            display: "inline-grid",
          }}
        >
          {vacations.map(({ id, start_date, end_date }) => (
            <SlotTimeList
              key={id}
              start_date={start_date}
              end_date={end_date}
              editVacation={() => editVacation(id, start_date, end_date)}
              handleDeleteVacation={() => handleDeleteVacation(id)}
            />
          ))}
        </div>
      ) : (
        !showLoader && (
          <div className="no-vacation-message">
            No vacations have been added to your calendar
          </div>
        )
      )}
    </>
  );
};

export default VacationList;
